export default __webpack_public_path__ + "static/media/peru-flag.cb76eb1b.svg";